import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { global } from '@angular/core/src/util';
import { GlobalProvider } from '../global/global';
import { empty } from 'rxjs/Observer';

/*
  Generated class for the ReunionProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ReunionProvider {


  private api: string;

  //private api;
  // , public  rurasdirective : RutasDirective
  constructor(public http: Http, public global: GlobalProvider) {
    this.api = this.global.api;
    console.log('Hello PaisProvider Provider');
    //this.api = rurasdirective.ruta;
  }

  // Devuelve todos el reunion de un congreso
  public all(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };


    return this.http.post(this.api + "reunion/lista.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public alletiquetas(clavecongreso, etiqueta): Observable<any> {
    if (etiqueta != null && etiqueta != "") {
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      let parametros = {
        "dispositivo": this.global.guid,
        "claveusuario": this.global.usuario,
        "token": this.global.token,
        "clavecongreso": clavecongreso,
        "etiqueta": etiqueta
      };


      return this.http.post(this.api + "reunion/listaetiquetasreunionfiltro.php", parametros, options).map(
        (response) => {

          return response.json();

        }
      ).catch(this.handleError);

    } else {
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      let parametros = {
        "dispositivo": this.global.guid,
        "claveusuario": this.global.usuario,
        "token": this.global.token,
        "clavecongreso": clavecongreso
      };


      return this.http.post(this.api + "reunion/listaetiquetasreunion.php", parametros, options).map(
        (response) => {

          return response.json();

        }
      ).catch(this.handleError);
    }

  }
  public alletiquetasAsistentes(clavecongreso, etiqueta): Observable<any> {
    if (etiqueta != null && etiqueta != "") {
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      let parametros = {
        "dispositivo": this.global.guid,
        "reuniones_pasadas": this.global.congresoglobal.reuniones_pasadas,
        "claveusuario": this.global.ficha_asistente.clave,
        "token": this.global.token,
        "clavecongreso": clavecongreso,
        "etiqueta": etiqueta
      };
      console.log(parametros);
      console.log('si eti');
      return this.http.post(this.api + "reunion/listaetiquetasreunioncategoriasfiltro.php", parametros, options).map(
        (response) => {
          console.log(response);
          return response.json();

        }
      ).catch(this.handleError);
    } else {
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      let parametros = {
        "dispositivo": this.global.guid,
        "reuniones_pasadas": this.global.congresoglobal.reuniones_pasadas,
        "claveusuario": this.global.ficha_asistente.clave,
        "token": this.global.token,
        "clavecongreso": clavecongreso
      };
      console.log(parametros);
console.log('no eti');
      return this.http.post(this.api + "reunion/listaetiquetasreunioncategorias.php", parametros, options).map(
        (response) => {
          console.log(response);
          return response.json();

        }
      ).catch(this.handleError);
    }
  }
  public allasistente(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "clavecongreso": clavecongreso,
      "claveasistente": this.global.ficha_asistente.clave
    };


    return this.http.post(this.api + "reunion/listaasistentes.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public allnotitulo(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };


    return this.http.post(this.api + "reunion/listanotitulo.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }


  // Devuelve todos el reunion de un congreso
  public preguntaslist(clavepregunta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "tabla": "preguntasasistentes",
      "campofiltro": "clavereunion",
      "valorfiltro": clavepregunta,
      "campoorden": "fecha"
    };


    return this.http.post(this.api + "apigen/list.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }

  // Devuelve todos los asistentes de un reunion
  public preguntaasistente(clavereunion, texto): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "clavereunion": clavereunion,
      "usuario": this.global.usuario,
      "texto": texto,
      "token": this.global.token
    };


    return this.http.post(this.api + "congresos/preguntasasistentes.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }

  public reunion_favoritos(clavereunion, operacion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "clavereunion": clavereunion,
      "token": this.global.token
    };


    if (operacion == 1) {
      return this.http.post(this.api + "reunion/insert.php", parametros, options).map(
        (response) => {

          return response.json();

        }
      ).catch(this.handleError);
    } else {
      return this.http.post(this.api + "reunion/delete.php", parametros, options).map(
        (response) => {

          return response.json();

        }
      ).catch(this.handleError);
    }

  }



  // Devuelve todos los reuniones de un asistente
  public reunionasistentes(claveasistente): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "claveasistente": claveasistente
    };


    return this.http.post(this.api + "congresos/reunionasistentes.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }


  // Devuelve todos los asistentes de un reunion
  public asistentesreunion(clavereunion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavereunion": clavereunion,
      "clavecongreso": this.global.congresoglobal.clave
    };


    return this.http.post(this.api + "reunion/listaasistentesreunion.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  // Devuelve todos los asistentes de un reunion
  public asistentesreunionaceptados(clavereunion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavereunion": clavereunion,
      "clavecongreso": this.global.congresoglobal.clave
    };


    return this.http.post(this.api + "reunion/listaasistentesreunionaceptados.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  // Devuelve todos los asistentes de un reunion
  public asistentesreunionestado(clavereunion, id): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavereunion": clavereunion,
      "id": id,
      "clavecongreso": this.global.congresoglobal.clave
    };

    console.log(parametros);
    return this.http.post(this.api + "reunion/listaasistentesreunionestado.php", parametros, options).map(
      (response) => {
        console.log(response);
        return response.json();

      }
    ).catch(this.handleError);
  }
  public preguntasreunion(clavepregunta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavepregunta": clavepregunta
    };

    return this.http.post(this.api + "congresos/preguntasreunion.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }
  public reunionpreguntas(clavereunion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavereunion": clavereunion
    };

    return this.http.post(this.api + "reunion/preguntasreunion.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }
  public documentosreunion(clavedocumento): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavedocumento": clavedocumento
    };

    return this.http.post(this.api + "congresos/documentosreunion.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }

  // Inserta en el reunion.  
  public insert(congresoactivo, evento): Observable<any> {


    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "tabla": "reuniones",
      "parametros": evento,
      "clavecongreso": congresoactivo.clave
    };

    console.log(parametros);
    return this.http.post(this.api + "apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta en el reunion.  
  public update(congresoactivo, evento): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "tabla": "reuniones",
      "clave": evento.clave,
      "parametros": evento,
      "clavecongreso": congresoactivo.clave
    };
    console.log(parametros);

    return this.http.post(this.api + "apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }

  // Elimina un congreso
  public delete(nnreunion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "reuniones",
      "clave": nnreunion,
    };


    return this.http.post(this.api + "apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }



  // Inserta en el reunion.  
  public guardaasistentes(clavereunion, asistentes): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "clavereunion": clavereunion,
      "asistentes": asistentes
    };
    console.log(parametros);

    return this.http.post(this.api + "reunion/asistentesreunion.php", parametros, options).map(
      (response) => {
        console.log(response);
        return response.json();
      }
    ).catch(this.handleError);
  }

  public guardapreguntas(clavereunion, preguntas): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "clavereunion": clavereunion,
      "preguntas": preguntas
    };

    console.log(parametros);
    console.log(this.api + "reunion/guardapreguntas.php");
    return this.http.post(this.api + "reunion/guardapreguntas.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta en el reunion.  
  public guardareunionpregunta(clavepregunta, reuniones): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "clavepregunta": clavepregunta,
      "reuniones": reuniones
    };


    return this.http.post(this.api + "congresos/guardapreguntasreunion.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }
  // Inserta en el reunion.  
  public guardareuniondocumento(clavedocumento, reuniones): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "clavedocumento": clavedocumento,
      "reuniones": reuniones
    };


    return this.http.post(this.api + "congresos/guardadocumentosreunion.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Valora una ponencia
  public valorarreunion(clavereunion, valoracion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavereunion": clavereunion,
      "dispositivo": this.global.guid,
      "valoracion": valoracion
    };

    return this.http.post(this.api + "congresos/valorarreunion.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }



  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

  // Rutina de errores
  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/providers/reunion/reunion.ts